export enum HeatInstallationTypeEnum {
  Heating = 'heating',
  HeatingAndCooling = 'heatingAndCooling',
}
